<div
  [ngClass]="'ub-' + mainScreen"
  class="ub-node-status-container"
  [class.ub-node-status-header]="mainScreen === 'editing_projection'"
>
  <h3 class="font-size-24" [class.ub-node-status-header-title]="mainScreen === 'editing_projection'">
    @if ( actionEvents.length && (actionEvents[0].count || actionEvents[0].count == 0) ) {
    <span>{{ actionEvents[0].count }}</span>
    }
    <span>{{ nodeStatus?.label | translate }}</span>
    @if (nodeStatus?.info_message) {
    <span class="ml-3 info-round-container">
      <span
        class="ubicon-info-round"
        matTooltipClass="ub-tooltip"
        matTooltip="{{ nodeStatus?.info_message | translate }}"
      ></span>
    </span>
    }
  </h3>

  @if (actionEvents.length) {
  <div
    class="ub-node-status-actions"
    [class.ub-node-status-header-actions]="mainScreen === 'editing_projection'"
  >
    @for (actionEvent of actionEvents; track $index) { @for (control of actionEvent?.controls; track
    $index) {
    <!-- BUTTONS -->
    @if (control?.display) { @if (control?.type == 'button' && control?.display) {
    <button
      mat-button
      [class]="
        (control?.class || 'ub-button ub-button-primary') +
        ' ga-top_bar_node_status_' +
        control?.label +
        (mainScreen === 'editing_projection' ? ' ub-node-status-header-btn' : '')
      "
      [disabled]="control?.mode === 'disable'"
      (click)="userClick(control)"
    >
      {{ control?.label | translate }}
    </button>
    } }
    <!-- BUTTONS -->

    <!-- DROPDOWN -->
    @if (control?.type == 'dropdown' && control?.display !== false) {
    <div class="dropdown-control-item filter-input-container flex-grow-1 tx-topbar-select">
      <mat-form-field appearance="outline" class="ub-form-select">
        <mat-select
          [value]="control?.default_selected"
          panelClass="tx-topbar-select-panel"
          disableOptionCentering
          (selectionChange)="selectionChange({ key: control?.key, value: $event?.value })"
        >
          @for (data of control?.dataset; track $index) {
          <mat-option [value]="data?.key">
            {{ data?.label | translate }} {{ data?.sub_label }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    }
    <!-- DROPDOWN -->

    <!-- Label -->
    @if (control?.type == 'label') { @if (control?.display) {
    <div class="node-status-top root-node">
      @if (control?.label) {
      <span class="status-label bold">
        {{ control?.label | translate }}
      </span>
      } @if (control?.value?.length) { @for (value of control?.value; track $index) {
      <span
        class="mac-address bold elepsis"
        matTooltipClass="ub-tooltip"
        matTooltip="{{ value }}"
        >{{ value }}</span
      >
      } }
    </div>
    } }
    <!-- Label -->
    } }
  </div>
  } @if (nodeStatus?.legends?.length) {
  <div class="ub-node-status-list" #getHeightTop>
    @for (legends of nodeStatus?.legends; track $index) { @if (legends.display) {
    <div
      class="ub-list-item"
      (click)="legends?.isClickable && onNodeStatusClick(legends)"
      [ngClass]="legends?.isClickable ? 'is-clickable' : ''"
    >
      <span [ngClass]="'data-icon ' + legends?.icon" class="ub-icon"></span>
      @if (legends?.count || legends?.count == 0) {
      <span class="ub-value">
        {{ legends?.count }}
      </span>
      } @if (legends?.label) {
      <span class="ub-form-label">
        {{ legends?.label | translate }}
      </span>
      }
    </div>
    } }
  </div>
  }
  <!-- AQI -->
  @if (mainScreen == 'aqi' && (subScreen == 'operational' || subScreen == 'maintenance')) { @if
  (offlineNodes !== 0 || powerLossNodes !== 0) {
  <div class="ub-node-status-list">
    <div class="ub-list-item">
      <span class="ub-icon data-icon off-icon"></span>
      <span class="ub-value">{{ 'off_tag' | translate }}</span>
    </div>
  </div>
  }

  <div class="ub-aqi-range-bar">
    @for (box of rangeBarJson; track $index; let i = $index) { @if (node == null || node?.LPState ==
    -1 || node?.LPState == -2) {
    <div
      matTooltipClass="ub-tooltip"
      [matTooltip]="box?.risk_level | lowercase | translate"
      [ngStyle]="{
        'background-color': box.hex_color,
        color: box.font_color
      }"
      class="ub-range-box"
    >
      {{ box.range }}
    </div>
    } @if ( node && node?.LPState != -1 && node?.LPState != -2 && node?.sensor_status?.status !=
    'NA' && ((node[customPollutantKey] >= box.min_value && node[customPollutantKey] <=
    box.max_value) || (node[customPollutantKey] < lowRange && i == 0) || (node[customPollutantKey] >
    highRange && rangeLength == i)) && !( !node?.sensor_initialized && ((node?.aqi == -1 &&
    (customPollutantKey == 'pm10' || customPollutantKey == 'pm2_5' || customPollutantKey == 'aqi'))
    || customPollutantKey == 'no2' || customPollutantKey == 'o3' || customPollutantKey == 'so2') ) )
    {
    <div
      matTooltipClass="ub-tooltip"
      [matTooltip]="box?.risk_level | lowercase | translate"
      [ngStyle]="{
        'background-color': box.hex_color,
        color: box.font_color,
        'font-weight': '600'
      }"
      class="ub-range-box-active ub-range-box"
    >
      {{ box.range }}
      {{ box.risk_level | lowercase | translate }}
    </div>
    } @if ( node && node?.LPState != -1 && node?.LPState != -2 && node?.sensor_status?.status !=
    'NA' && !( (node[customPollutantKey] >= box.min_value && node[customPollutantKey] <=
    box.max_value) || (node[customPollutantKey] < lowRange && i == 0) || (node[customPollutantKey] >
    highRange && rangeLength == i) ) && !( !node?.sensor_initialized && ((node?.aqi == -1 &&
    (customPollutantKey == 'pm10' || customPollutantKey == 'pm2_5' || customPollutantKey == 'aqi'))
    || customPollutantKey == 'no2' || customPollutantKey == 'o3' || customPollutantKey == 'so2') ) )
    {
    <div
      matTooltipClass="ub-tooltip"
      [matTooltip]="box?.risk_level | lowercase | translate"
      [ngStyle]="{
            'background-color': box.hex_color,
          }"
      class="ub-range-box-selected"
    ></div>
    } @if ( node && node?.LPState != -1 && node?.LPState != -2 && (node?.sensor_status?.status ==
    'NA' || (!node?.sensor_initialized && ((node?.aqi == -1 && (customPollutantKey == 'pm10' ||
    customPollutantKey == 'pm2_5' || customPollutantKey == 'aqi')) || customPollutantKey == 'no2' ||
    customPollutantKey == 'o3' || customPollutantKey == 'so2'))) ) {
    <div
      matTooltipClass="ub-tooltip"
      [matTooltip]="box?.risk_level | lowercase | translate"
      [ngStyle]="{
        'background-color': box.hex_color,
        color: box.font_color
      }"
      class="ub-range-box"
    >
      {{ box.range }}
    </div>
    } }
  </div>
  }
  <!-- AQI -->

  @if (displayViewOption?.length) {
  <div class="switch-icons">
    @for (view of displayViewOption; track $index) {
    <a
      (click)="switchDisplayView(view.key)"
      [class]="view?.class"
      [ngClass]="view.key == selectedViewType ? 'active' : ''"
    >
      <span [class]="view?.icon_class"></span>
      <span class="switch-icon-names">{{ view?.label | translate }}</span>
    </a>
    }
  </div>
  }
</div>
